/**
 * HTTP service for the rate-cards feature (PX-W6.4): the four endpoints of
 * `RateCardController` (`server/conf/routes`, verified 2026-09-04). Org-level
 * surface — no project in the path. Reads are plain `@Authenticated`; create
 * and close are `@Authenticated(orgAdmin=true)` server-side; the client gates
 * the DESTINATION declaratively (roleAccess) and never re-checks.
 *
 * Append-only by construction: there is no edit verb here and no edit verb
 * anywhere — a correction is a new row, an ending is the close.
 */

import { apiClient } from '@/services'

import type { CloseRateCardInput, CreateRateCardInput, RateCard } from '../types'

export const rateCardServiceHttp = {
  /** The org's rate-card rows (`GET /rate-cards`). */
  list(): Promise<RateCard[]> {
    return apiClient.get<RateCard[]>('/{orgId}/rate-cards')
  },

  /** One card. */
  get(cardId: string): Promise<RateCard> {
    return apiClient.get<RateCard>(`/{orgId}/rate-cards/${cardId}`)
  },

  /** Create a row (`POST /rate-cards`); overlapping windows on the same key are refused. */
  create(input: CreateRateCardInput): Promise<RateCard> {
    return apiClient.post<RateCard>('/{orgId}/rate-cards', input)
  },

  /** Close a row (`POST /rate-cards/:cardId/close`) — the ONLY write on an existing card. */
  close(cardId: string, input: CloseRateCardInput): Promise<RateCard> {
    return apiClient.post<RateCard>(`/{orgId}/rate-cards/${cardId}/close`, input)
  }
}
